// extracted by mini-css-extract-plugin
export var activeDot = "_47-c";
export var buttonContainer = "_47-9";
export var channelButton = "_47-a";
export var clickable = "_47-d";
export var content = "_47-0";
export var contentFull = "_47-2";
export var contentThird = "_47-1";
export var contentWrapper = "_47-7";
export var description = "_47-5";
export var heightShort = "_47-f";
export var image = "_47-3";
export var imageContainer = "_47-4";
export var selectButton = "_47-e";
export var spinnerContainer = "_47-b";
export var titleContent = "_47-8";
export var titleWrapper = "_47-6";